// AWS Configuration
// You'll need to update these values after deploying your CDK stack

export const awsConfig = {
  // Cognito Configuration
  cognito: {
    userPoolId: 'us-east-2_Rr4X3jS4y', // From CDK output: UserPoolId
    userPoolClientId: '1c8db5jq0ue8u2iq5amvr4d4id', // From CDK output: UserPoolClientId
    domain: 'https://pretty-docs-dev-47r5p.auth.us-east-2.amazoncognito.com', // From CDK output: UserPoolDomainUrl
    region: 'us-east-2', // Update with your AWS region
  },
  
  // API Configuration
  api: {
    baseUrl: 'https://5u6oxp6o00.execute-api.us-east-2.amazonaws.com/prod', // From CDK output: ApiGatewayUrl
    region: 'us-east-2', // Update with your AWS region
  },
  
  // WebSocket Configuration
  websocket: {
    url: 'wss://e9d2ndiuh7.execute-api.us-east-2.amazonaws.com/dev', // From CDK output: WebSocketUrl
  },
  
  // S3 Configuration
  s3: {
    inputBucket: 'pretty-docs-input-dev-475141304303', // From CDK output: InputBucketName
    outputBucket: 'pretty-docs-output-dev-475141304303', // From CDK output: OutputBucketName
    region: 'us-east-2', // Update with your AWS region
  }
};

// Amplify Configuration
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: awsConfig.cognito.userPoolId,
      userPoolClientId: awsConfig.cognito.userPoolClientId,
      loginWith: {
        oauth: {
          domain: awsConfig.cognito.domain.replace('https://', ''),
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: ['http://localhost:3000/'],
          redirectSignOut: ['http://localhost:3000/'],
          responseType: 'code' as const,
        },
        email: true,
      },
    },
  },
  API: {
    REST: {
      PrettyDocsApi: {
        endpoint: awsConfig.api.baseUrl,
        region: awsConfig.api.region,
      },
    },
  },
};
